import React from 'react';
import { getHobbyMediaStyle, HobbyMediaIcon, normalizeHobbyMediaId } from '../../content/hobbyMedia';

/** Shows a hobby library's empty state without duplicating the header's Add action. */
export default function HobbyEmptyState({ hobbyId, title, detail, filtered = false }) {
  if (filtered) {
    return <div className="empty-state"><h3>{title}</h3>{detail && <p>{detail}</p>}</div>;
  }

  const mediaId = normalizeHobbyMediaId(hobbyId);
  const { accent } = getHobbyMediaStyle(mediaId);

  return (
    <div className="hobby-empty-state" style={{ '--hobby-empty-accent': accent }}>
      <span className="hobby-empty-state-icon" aria-hidden="true"><HobbyMediaIcon type={mediaId} /></span>
      <h3>{title}</h3>
      {detail && <p>{detail}</p>}
    </div>
  );
}
